import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { IProject, useGlobalState } from '@src/context/GlobalStateContext';
import api from '@src/services/axios';
import { useUpdatePerEventQuery } from '@src/services/queries/useEventsQuery';
import { useProjectsQuery } from '@src/services/queries/useProjectQuery';
import { Project } from '@src/types';
import { formatNumber } from '@src/utils/format-number';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import IconBack from './Element/IconBack';
import './payment.css';

export default function Offset({ eventId }: { eventId: number }) {
    const { projectSelect, setProjectSelect } = useGlobalState();
    const updatePerEventQuery = useUpdatePerEventQuery();
    const { t } = useTranslation();
    const projectsQuery = useProjectsQuery(true);

    const [projects, setProjects] = useState<Project[]>([]);
    const [selectedValue, setSelectedValue] = useState<string | null>('');

    const [totalCarbonFootprint, setTotalCarbonFootprint] = useState<number>(0);

    const handleChange = (e: React.MouseEvent<HTMLElement>, nextView: string) => {
        const resultFilter = projects?.find(p => p.id === parseInt(nextView));
        setProjectSelect({
            id: resultFilter?.id.toString(),
            price: resultFilter?.price,
            quantity: resultFilter?.quantity,
        } as IProject);
        setSelectedValue(nextView);
    };
    // const { totalCarbonFootprint } = useMemo(() => {
    //     return (gasEmissions || []).reduce(
    //         (totals: any, source: EmissionsSource) => {
    //             totals.totalCarbonFootprint += source.total / 1000;
    //             return totals;
    //         },
    //         { totalCarbonFootprint: 0 },
    //     );
    // }, [gasEmissions]);

    // const totalCarbonFootprint2 = Math.ceil(totalCarbonFootprint);

    const autoSetProject = useCallback(() => {
        if (projects?.length > 0) {
            const projectFind = projects?.find(p => p.id === parseInt(selectedValue as string));
            setProjectSelect({
                id: projectFind?.id.toString(),
                price: projectFind?.price,
                quantity: projectFind?.quantity,
            } as IProject);
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projects]);

    useEffect(() => {
        if (projectSelect && projectSelect?.id) {
            setSelectedValue(projectSelect.id.toString());
            autoSetProject();
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [autoSetProject]);

    const handleNext = async () => {
        const response = await updatePerEventQuery.mutateAsync({
            eventId: eventId,
            preEvent: {
                projectId: parseInt(projectSelect?.id as string),
            },
        });

        let tmpCreateData = {
            status: 'post',
            paging: 9,
        };
        sessionStorage.setItem('tmpCreateData', JSON.stringify(tmpCreateData));

        if (response.status === 200) {
            window.location.href = '/register/post/9';
        } else {
            Swal.fire({
                icon: 'error',
                title: 'เกิดข้อผิดพลาด!',
                text: 'ไม่สามารถดำเนินการต่อไปได้',
                confirmButtonText: 'ตกลง',
            });
        }
    };

    const handleBack = () => {
        let tmpCreateData = {
            status: 'post',
            paging: 7,
        };
        sessionStorage.setItem('tmpCreateData', JSON.stringify(tmpCreateData));
        window.location.href = '/register/post/7';
    };

    const handleCancel = () => {
        setSelectedValue('');
    };

    const fetchDataEvent = React.useCallback(async () => {
        try {
            const { data } = await api.get(`/events/${eventId}`);
            setTotalCarbonFootprint(Math.ceil(data?.emission?.summary ?? 0));
            console.log(data);
        } catch (error) {
            console.error('Error fetching event data:', error);
        }
    }, [eventId, setTotalCarbonFootprint]);

    useEffect(() => {
        if (eventId) {
            fetchDataEvent();
        }
    }, [fetchDataEvent, eventId]);

    useEffect(() => {
        if (projectsQuery?.data && totalCarbonFootprint) {
            const { data } = projectsQuery?.data;
            const newProjects = data.data.filter((p: any) => p.quantity >= totalCarbonFootprint);
            setProjects(newProjects);
            if (newProjects.length === 0) {
                setSelectedValue('');
                setProjectSelect(undefined as any);
            }
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectsQuery?.data, totalCarbonFootprint]);
    return (
        <div className="flex justify-center px-4 md:px-0">
            <div className="w-full md:w-2/3 lg:w-7/12 xl:w-7/12">
                <div className="box mt-5 md:mt-20 rounded-3xl md:rounded-[90px] p-4 md:p-8 overflow-hidden">
                    <div className="columns ">
                        <div className="column mt-5 px-2 md:px-4">
                            <h1 className="content-header text-left flex items-center gap-2 md:gap-3 text-xl md:text-2xl lg:text-3xl font-bold mb-4">
                                <IconBack onClick={handleBack} />
                                <span className="truncate">{t('PAID_PAGE.HEADER')}</span>
                            </h1>
                            <br />
                            <div className="w-full  md:max-w-md mx-auto my-3">
                                <div className="border-[#B5D224] border-4 md:border-8 p-4 md:p-8 rounded-xl">
                                    <div className="text-sky-500 text-3xl md:text-4xl lg:text-5xl font-Kanit font-bold text-center">
                                        {totalCarbonFootprint}
                                        {t('SUMMARY_PAGE.UNIT')}
                                    </div>
                                </div>
                            </div>
                            {selectedValue && (
                                <div className="flex justify-end p-2 md:p-4">
                                    <div className="cursor-pointer underline text-base md:text-lg" onClick={handleCancel}>
                                        {t('CANCEL_PROJECT')}
                                    </div>
                                </div>
                            )}
                            {projects.length > 0 && (
                                <ToggleButtonGroup
                                    className="gap-y-2 w-full max-w-full"
                                    color="info"
                                    exclusive
                                    value={selectedValue}
                                    orientation="vertical"
                                    onChange={handleChange}
                                >
                                    {projects?.map((project: Project) => (
                                        <ToggleButton
                                            key={project.id}
                                            value={project.id.toString()}
                                            aria-label="list"
                                            className="w-full rounded-lg block normal-case border-gray-300 overflow-hidden"
                                            sx={{
                                                borderColor: '#E2E2E2',
                                                textTransform: 'none',
                                                padding: '12px 16px',
                                            }}
                                        >
                                            <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 md:gap-4 w-full">
                                                <Tooltip title={project.nameTH ?? ''} placement="bottom-start">
                                                    <div className="text-left text-base md:text-lg truncate w-full min-w-0 flex-1">
                                                        {project.nameTH ?? ''}
                                                    </div>
                                                </Tooltip>

                                                <div className="text-left md:text-right text-black text-base md:text-lg w-full md:w-auto md:min-w-[140px] flex-shrink-0">
                                                    <div className="font-medium">
                                                        {formatNumber(project.price)} / {'1'}
                                                    </div>
                                                    <div className="text-xs md:text-sm text-gray-600 mt-1">{t('PAID_PAGE.CURRENCY_EXCHANGE_RATE')}</div>
                                                </div>
                                            </div>
                                        </ToggleButton>
                                    ))}
                                </ToggleButtonGroup>
                            )}

                            {projects.length === 0 && (
                                <div className="text-center md:text-left">
                                    <p className="text-lg md:text-xl">
                                        {t('NO_PROJECT')}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="columns mt-4">
                        <div className="column w-full md:w-2/3 lg:w-1/2 mx-auto px-4 md:px-0" style={{ alignItems: 'right', marginTop: '10px' }}>
                            <button
                                onClick={handleNext}
                                className="button is-large is-fullwidth App w-full h-14 md:h-16 lg:h-[70px] text-base md:text-lg"
                                style={{ backgroundColor: '#B5D224', borderRadius: '15px' }}
                                disabled={selectedValue === '' || projects.length === 0}
                            >
                                {t('BUTTONS.NEXT')}
                            </button>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
        </div>
    );
}
